import React, { useState, useEffect } from 'react';
import {Grid, Typography} from "@mui/material";
import {NewPost} from "../Content/NewPost";
import axios from '../../../config/axios';
import { useHistory } from 'react-router-dom';
import {useTranslation} from "react-i18next";

// Use same fallback as UserProfile.js
const profilepic1 = '/blogger.jpg';

const styles = {
    title: {
        fontFamily: 'Montserrat',
        fontSize: '20px',
        fontWeight: '500',
        lineHeight: '24px',
    },
    name: {
        fontFamily: 'Montserrat',
        fontSize: '16px',
        fontWeight: '600',
        lineHeight: '20px',
    },
    role: {
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '17px',
    },
    button: {
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '20px',
        letterSpacing: '0.10000000149011612px',
        textAlign: 'center',
    }
}

function PopularWriters({axiosPosts, axiosUsersRoles, loading, usersrolesLoading, axiosProfiles}) {
    const history = useHistory();
    const [followedUsers, setFollowedUsers] = useState(new Set());
    const [loadingFollow, setLoadingFollow] = useState({});
    const {t} = useTranslation();

    // Get current user fresh each render to handle login state changes
    const getCurrentUser = () => {
        try {
            return JSON.parse(localStorage.getItem('user'));
        } catch {
            return null;
        }
    };

    const isLoggedIn = () => {
        return !!localStorage.getItem('AUTHORIZATION_TOKEN_BLOG');
    };

    // Fetch current user's following list on mount
    useEffect(() => {
        const currentUser = getCurrentUser();
        if (currentUser?.id) {
            axios.get(`/follow/${currentUser.id}/following`)
                .then(response => {
                    const data = Array.isArray(response.data) ? response.data : [];
                    const followedIds = new Set(data.map(f => f.followed_id));
                    setFollowedUsers(followedIds);
                })
                .catch(err => console.error('Error fetching following:', err));
        }
    }, []);

    const handleFollow = async (userId) => {
        const currentUser = getCurrentUser();

        if (!currentUser || !isLoggedIn()) {
            window.location.href = '/login';
            return;
        }

        if (!userId) {
            return;
        }

        setLoadingFollow(prev => ({ ...prev, [userId]: true }));

        try {
            if (followedUsers.has(userId)) {
                // Unfollow - axios interceptor adds token automatically
                await axios.delete(`/follow/${userId}`);
                setFollowedUsers(prev => {
                    const newSet = new Set(prev);
                    newSet.delete(userId);
                    return newSet;
                });
            } else {
                // Follow - axios interceptor adds token automatically
                await axios.post(`/follow/${userId}`, {});
                setFollowedUsers(prev => new Set([...prev, userId]));
            }
        } catch (err) {
            console.error('Error following/unfollowing:', err.response?.data?.message || err.message);
        } finally {
            setLoadingFollow(prev => ({ ...prev, [userId]: false }));
        }
    };

    let users = [];
    //Create list of popular writes
    for (let i = 0; i < axiosUsersRoles.length; i++) {
        let viewcount = 0;
        users[i] = new NewPost(axiosUsersRoles[i].user.id, null, null, null, null, null, null, null)

        //Checks if user has a middle name and set it to their fullname
        if (axiosUsersRoles[i]?.user?.middlename) {
            let abbreviatedMiddleName = axiosUsersRoles[i]?.user?.middlename.slice(0, 1).concat('.');
            let fullName = axiosUsersRoles[i]?.user?.firstName + ' '
                + abbreviatedMiddleName + ' '
                + axiosUsersRoles[i]?.user?.lastName;
            users[i].setFullName(fullName);
        } else {
            let fullName = axiosUsersRoles[i]?.user?.firstName + ' ' + axiosUsersRoles[i]?.user?.lastName;
            users[i].setFullName(fullName);
        }

        //Set the user's role
        users[i].setRole(axiosUsersRoles[i]?.roles[0]?.role);
        // Get profile photo from axiosProfiles
        const userProfile = axiosProfiles?.find(p => p.userId === axiosUsersRoles[i].user.id);
        users[i].setProfilePhoto(userProfile?.photo || null);

        //Set the user's viewcount
        for (let j = 0; j < axiosPosts.length; j++) {
            if (axiosUsersRoles[i].user.id === axiosPosts[j].userId) {
                viewcount += axiosPosts[j].viewcount;
            }
        }
        users[i].setViewCount(viewcount);
    }

    //Sort list from most popular to the least popular
    for (let i = 0; i < users.length - 1; i++) {
        for (let j = i + 1; j < users.length; j++) {
            if (users[i]?.viewCount < users[j]?.viewCount) {
                const temp = users[i];
                users[i] = users[j];
                users[j] = temp;
            }
        }
    }

    //console.log('Users = ', users);
    const popularWriters = [users[0], users[1], users[2], users[3]];
    const currentUser = getCurrentUser();

    return (
        loading || usersrolesLoading
            ? <Grid container>Popular Users Loading</Grid>
            :
            <>
                <Grid container direction={'column'}>
                    <Grid item>
                        <Typography style={styles.title}>
                            {t('Popular writers to follow')}
                        </Typography>
                    </Grid>

                    {/* List of popular writers */}
                    <Grid item container direction={'column'}>
                        {
                            popularWriters.map((user, index) => (
                                <Grid key={index} item container direction={'row'} alignItems={'center'}
                                      justifyContent={'center'}
                                      className={'popularWriters'}>
                                    {/* Profile picture */}
                                    <Grid item xs={2}>
                                        <img className={'usersProfilePicture'}
                                            src={user?.profilePhoto || profilepic1}
                                            alt={'Profile thumbnail'}
                                            style={{width: 50, height: 50, borderRadius: '50%', objectFit: 'cover', cursor: 'pointer'}}
                                            onClick={() => history.push(`/profile/${user?.id}`)}
                                            onError={(e) => { e.target.src = profilepic1; }}
                                        />
                                    </Grid>
                                    {/* Name and Role / Certification */}
                                    <Grid item container direction={'column'} xs={7}>
                                        <Typography
                                            style={{...styles.name, cursor: 'pointer'}}
                                            onClick={() => history.push(`/profile/${user?.id}`)}
                                        >
                                            {user?.fullName}
                                        </Typography>
                                        <Typography style={styles.role}>
                                            {user?.role}
                                        </Typography>
                                        <Typography style={{...styles.role, color: '#6750A4', fontSize: '12px'}}>
                                            {user?.viewCount || 0} {t('total views', { defaultValue: 'total views' })}
                                        </Typography>
                                    </Grid>
                                    <Grid item container justifyContent={'center'} xs={3}>
                                        <Grid item>
                                            {currentUser?.id !== user?.id && (
                                                <button
                                                    onClick={() => handleFollow(user?.id)}
                                                    disabled={loadingFollow[user?.id]}
                                                    style={{
                                                        backgroundColor: followedUsers.has(user?.id) ? '#e0e0e0' : '#6750A4',
                                                        color: followedUsers.has(user?.id) ? '#333' : '#fff',
                                                        border: 'none',
                                                        borderRadius: '20px',
                                                        padding: '8px 16px',
                                                        cursor: loadingFollow[user?.id] ? 'wait' : 'pointer'
                                                    }}
                                                >
                                                    <Typography style={styles.button}>
                                                        {loadingFollow[user?.id]
                                                            ? '...'
                                                            : followedUsers.has(user?.id)
                                                                ? t('Following')
                                                                : t('Follow')}
                                                    </Typography>
                                                </button>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))
                        }

                        {/*<Grid item container direction={'row'} alignItems={'center'} justifyContent={'center'}>
                     Profile picture
                    <Grid item xs={2}>
                        <img src={profilepic1}/>
                    </Grid>
                     Name and Role/Certification
                    <Grid item container direction={'column'} xs={7}>
                        <Typography>
                            {popularWriters[0]?.fullName}
                        </Typography>
                        <Typography>
                            {'SE School Teacher'}
                        </Typography>
                    </Grid>
                    <Grid item container justifyContent={'center'} xs={3}>
                        <Grid item>
                            <button>
                                Follow
                            </button>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item container direction={'row'} alignItems={'center'} justifyContent={'center'}>
                     Profile picture
                    <Grid item xs={2}>
                        <img src={profilepic1}/>
                    </Grid>
                     Name and Role/Certification
                    <Grid item container direction={'column'} xs={7}>
                        <Typography>
                            {popularWriters[1]?.fullName}
                        </Typography>
                        <Typography>
                            {'SE School Teacher'}
                        </Typography>
                    </Grid>
                    <Grid item container justifyContent={'center'} xs={3}>
                        <Grid item>
                            <button>
                                Follow
                            </button>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item container direction={'row'} alignItems={'center'} justifyContent={'center'}>
                     Profile picture
                    <Grid item xs={2}>
                        <img src={profilepic1}/>
                    </Grid>
                     Name and Role/Certification
                    <Grid item container direction={'column'} xs={7}>
                        <Typography>
                            {popularWriters[2]?.fullName}
                        </Typography>
                        <Typography>
                            {'SE School Teacher'}
                        </Typography>
                    </Grid>
                    <Grid item container justifyContent={'center'} xs={3}>
                        <Grid item>
                            <button>
                                Follow
                            </button>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item container direction={'row'} alignItems={'center'} justifyContent={'center'}>
                     Profile picture
                    <Grid item xs={2}>
                        <img src={profilepic1}/>
                    </Grid>
                     Name and Role/Certification
                    <Grid item container direction={'column'} xs={7}>
                        <Typography>
                            {popularWriters[3]?.fullName}
                        </Typography>
                        <Typography>
                            {'SE School Teacher'}
                        </Typography>
                    </Grid>
                    <Grid item container justifyContent={'center'} xs={3}>
                        <Grid item>
                            <button>
                                Follow
                            </button>
                        </Grid>
                    </Grid>
                </Grid>*/}

                    </Grid>
                </Grid>
            </>
    )
}

export default PopularWriters;
